import firebase from "firebase/app"
import { PromotionDB } from "hero24-types"
import { FIREBASE_PATH_PROMOTIONS } from "../constants"

const addPromotion = async (promotion: PromotionDB) => {
  await firebase.database().ref(FIREBASE_PATH_PROMOTIONS).push(promotion)
}

export default addPromotion
